


































































































































































































































































































































































































































































































































































































































































































































import store from "../store";
import { inputs, printPage } from "../mixins/mixins";
const Finance = require("financejs");

export default {
  mixins: [inputs, printPage],

  data() {
    return {
      title: "Step 5",
      ss: store.state,
      dataEntry: 0,
      activateReadMore: false,
      tablesKey: 0,
      finance: new Finance(),
      dataHeaders: [
        {
          text: "Step #",
          sortable: false,
          value: "step"
        },
        {
          text: "Data type",
          sortable: false,
          value: "type"
        },
        {
          text: "Results that you have generated at previous steps",
          sortable: false,
          align: "center",
          value: "value"
        }
      ],
      step5Data: [
        {
          id: "11",
          step: "5",
          type: "Current fertiliser rate (kg fertiliser/ha/year)",
          value: store.state.step5.fertRate,
          precision: 0
        },
        {
          id: "12",
          step: "5",
          type: "Gross margin — current ($/DSE)",
          value: store.state.step5.currentGrossMargin,
          precision: 2
        },
        {
          id: "13",
          step: "5",
          type: "Gross margin — projected ($/DSE)",
          value: store.state.step5.projectedGrossMargin,
          precision: 2
        },
        {
          id: "14",
          step: "5",
          type: "Capital cost of extra livestock ($/DSE)",
          value: store.state.step5.extraLivestockCost,
          precision: 2
        },
        {
          id: "15",
          step: "5",
          type: "Fertiliser cost ($/tonne)",
          value: store.state.step5.fertCost,
          precision: 2
        },
        {
          id: "16",
          step: "5",
          type: "Fertiliser spreading cost ($/ha)",
          value: store.state.step5.fertSpread,
          precision: 2
        },
        {
          id: "17",
          step: "5",
          type: "Interest on debt (%)",
          value: store.state.step5.interestOnDebt,
          precision: 2
        },
        {
          id: "18",
          step: "5",
          type: "Area of pasture (ha)",
          value: store.state.step5.pastureArea,
          precision: 0
        }
      ]
    };
  },

  watch: {
    data(this:any) {
      this.tablesKey += 1;
    }
  },

  computed: {
    data: {
      get(this:any) {
        let data = [
          {
            id: "0",
            step: "1",
            type: "Current Soil " + store.state.step1.type + " P (mg P/kg)",
            value: store.state.step1.value,
            result: store.state.step1.value,
            precision: 0,
            readonly: true
          },
          {
            id: "1",
            step: "1",
            type:
              "Critical soil test level for near maximum pasture growth (mg P/kg)",
            value: null,
            result:
              store.state.step1.type === "Colwell"
                ? store.state.step1.colwellP
                : store.state.step1.olsenP,
            precision: 0,
            readonly: true
          },
          {
            id: "2",
            step: "2",
            type: "Current stocking rate (DSE/ha)",
            value: store.state.step2.stockingRateCurrent,
            result: store.state.step2.stockingRateCurrent,
            precision: 1,
            readonly: true
          },
          {
            id: "3",
            step: "2",
            type:
              "Potential carrying capacity with near optimal soil fertility (DSE/ha)",
            value: null,
            result: store.state.step2.potCarryingCapacity,
            precision: 1,
            readonly: true
          },
          {
            id: "4",
            step: "2",
            type: "Preferred target for soil P management (mg P/kg)",
            value:
              store.state.step2.type === "stockingRate"
                ? parseFloat(store.state.step2.fertilityTarget)
                : store.state.step2.target,
            result:
              store.state.step2.type === "stockingRate"
                ? parseFloat(store.state.step2.fertilityTarget)
                : store.state.step2.target,
            precision: 0,
            readonly: true
          },
          {
            id: "5",
            step: "2",
            type:
              "Stocking rate — at preferred target for soil fertility management (DSE/ha)",
            value:
              store.state.step2.type === "stockingRate"
                ? store.state.step2.target
                : parseFloat(store.state.step2.stockingRateTarget),
            result:
              store.state.step2.type === "stockingRate"
                ? store.state.step2.target
                : parseFloat(store.state.step2.stockingRateTarget),
            precision: 1,
            readonly: true
          },
          {
            id: "6",
            step: "3",
            type:
              "Timeframe — to achieve new soil fertility and stocking rate targets (years)",
            value: store.state.step3.years,
            result: store.state.step3.years,
            precision: 0,
            readonly: true
          },
          {
            id: "7",
            step: "3",
            type: "Stocking rate — yearly increase (DSE/ha)",
            value:
              (store.state.step2.target - store.state.step2.stockingRateCurrent) /
              store.state.step3.years,
            result:
              (store.state.step2.target - store.state.step2.stockingRateCurrent) /
              store.state.step3.years,
            precision: 1,
            readonly: true
          },
          {
            id: "8",
            step: "3",
            type: "Planned increase in soil P test (mg P/kg per year)",
            value:
              (store.state.step2.fertilityTarget - store.state.step1.value) /
              store.state.step3.years,
            result:
              (store.state.step2.fertilityTarget - store.state.step1.value) /
              store.state.step3.years,
            precision: 1,
            readonly: true
          },
          {
            id: "9",
            step: "3",
            type:
              "Fertiliser rate needed to increase soil P at required rate (kg/ha/year)",
            value: store.state.step3.fertiliserRate,
            result: store.state.step3.fertiliserRate,
            precision: 0,
            readonly: true
          },
          {
            id: "10",
            step: "3",
            type:
              "Maintenance fertiliser rate at target carrying capacity (kg/ha/year)",
            value: store.state.step3.maintenanceFertiliserRate,
            result: store.state.step3.maintenanceFertiliserRate,
            precision: 0,
            readonly: true
          },
        ];
        data = data.concat(this.step5Data);
        if (store.state.activeScenario) {
          if (store.state.activeScenario.step5.exportDataEntry) {
            store.state.activeScenario.step5.exportDataEntry.map((d:any, d_ix:number) => {
              if (d.step === "5") {
                data[d_ix] = d
              }
            })
          }
        }
        return data
      }
    },

    // Current Fertiliser Regime

    livestockGrossCurrent: function(this: any): number {
      // stockingRateCurrent * currentGrossMargin * pastureArea
      return (
        parseFloat(this.data[2].value) *
        parseFloat(this.data[12].value) *
        parseFloat(this.data[18].value)
      );
    },
    fertiliserCost: function(this: any): number {
      // (fertRate * fertCost * pastureArea) / 1000
      return (
        (this.data[11].value * this.data[15].value * this.data[18].value) / 1000
      );
    },
    fertiliserSpreadCost: function(this: any): number {
      // fertSpread * pastureArea
      return (
        this.data[16].value * this.data[18].value
      );
    },
    netCash: function(this: any): number {
      return (
        this.livestockGrossCurrent -
        this.fertiliserCost -
        this.fertiliserSpreadCost
      );
    },

    // Projected Fertiliser Regime

    stockingRateProjected: function(this: any): number[] {
      let arr: number[] = [];
      // (stockingRateTarget - stockingRateCurrent) / timeframeYears
      let srYearlyIncrease: number =
        (parseFloat(this.data[5].value) - parseFloat(this.data[2].value)) /
        parseFloat(this.data[6].value);
      for (let i = 0; i <= 10; i++) {
        if (i === 0) {
          // stockingRateCurrent
          arr.push(parseFloat(this.data[2].value));
          // stockingRateTarget
        } else if (arr[i - 1] + srYearlyIncrease < this.data[5].value) {
          arr.push(arr[i - 1] + srYearlyIncrease);
        } else {
          arr.push(parseFloat(this.data[5].value));
        }
      }
      return arr;
    },
    fertilserRate: function(this: any): number[] {
      let arr: number[] = [];
      // (fertilityTarget) - testValue / timeframeYears
      let plannedIncreaseInP = (this.data[4].value - this.data[0].value) / this.data[6].value;
      // let startYearForMaintenanceFertRate: number = this.data[6].value;
      for (let i = 0; i <= 10; i++) {
        if (i === 0) {
          // fertRate
          arr.push(this.data[11].value);
        } else if (plannedIncreaseInP !== 0) {
          // maintenanceFertiliserRate + (fertiliserRate - maintenanceFertiliserRate)
          /*if (i > startYearForMaintenanceFertRate) {
            arr.push(this.data[10].value);
          } else {*/
            arr.push(
              this.data[10].value + (
                (this.data[9].value - this.data[10].value) *
                  (this.increaseInSoilPRequired[i] / plannedIncreaseInP))
            );
          /*}*/
        }
      }
      return arr;
    },
    expectedSoilP: function(this: any): number[] {
      const currentP = parseFloat(this.data[0].value);
      const targetP = parseFloat(this.data[4].value);
      let arr: number[] = [];
      let expected = 0;
      let gap = 0;
      let increase = 0;
      for (let i = 0; i <= 10; i++) {
        if (i === 0) {
          expected = currentP;
          gap = targetP - expected;
        } else {
          gap = targetP - expected;
          increase = Math.min(this.data[8].value, gap)
          expected = expected + increase
        }
        arr.push(expected)
      }
      return arr;
    },
    gapToTargetSoilP: function(this: any): number[] {
      const targetP = parseFloat(this.data[4].value);
      let arr: number[] = [];
      for (let i = 0; i <= 10; i++) {
        arr.push(targetP - this.expectedSoilP[i])
      }
      return arr;
    },
    increaseInSoilPRequired: function(this: any): number[] {
      const plannedIncreaseInP = parseFloat(this.data[8].value);
      let arr: number[] = [];
      for (let i = 0; i <= 10; i++) {
        if (i === 0) {
          arr.push(0)
        } else {
          arr.push(Math.min(plannedIncreaseInP, this.gapToTargetSoilP[i - 1]))
        }
      }
      return arr;
    },
    grossMarginPerHead: function(this: any): any[] {
      let arr: number[] = [];
      for (let i = 0; i <= 10; i++) {
        if (i === 0) {
          // currentGrossMargin
          arr.push(this.data[12].value);
          // timeframeYears
        } else if (i > this.data[6].value) {
          // projectedGrossMargin
          arr.push(this.data[13].value);
        } else {
          // currentGrossMargin + i * (projectedGrossMargin - currentGrossMargin) / timeframeYears
          arr.push(
            this.data[12].value +
              (i * (this.data[13].value - this.data[12].value)) /
                this.data[6].value
          );
        }
      }
      return arr;
    },
    livestockGrossProjected: function(this: any): number[] {
      let arr: number[] = [];
      for (let i = 0; i <= 10; i++) {
        // pastureArea
        arr.push(
          this.grossMarginPerHead[i] * this.stockingRateProjected[i] * this.data[18].value
        );
      }
      return arr;
    },
    fertiliserCostProjected: function(this: any): number[] {
      let arr: number[] = [];
      for (let i = 0; i <= 10; i++) {
        // fertCost / 1000 * pastureArea
        arr.push(
          ((this.fertilserRate[i] * this.data[15].value) / 1000) *
            this.data[18].value
        );
      }
      return arr;
    },
    fertiliserSpreadCostProjected: function(this: any): number[] {
      let arr: number[] = [];
      for (let i = 0; i <= 10; i++) {
        if (this.fertilserRate[i] > 0) {
          // fertSpread * pastureArea
          arr.push(this.data[16].value * this.data[18].value);
        } else {
          arr.push(0);
        }
      }
      return arr;
    },
    livestockPurchaseCost: function(this: any): number[] {
      let arr: number[] = [0];
      for (let i = 0; i <= 9; i++) {
        // extraLivestockCost * pastureArea
        arr.push(
          (this.stockingRateProjected[i + 1] - this.stockingRateProjected[i]) *
            this.data[14].value *
            this.data[18].value
        );
      }
      return arr;
    },
    netCashProjected: function(this: any): number[] {
      let arr: number[] = [];
      for (let i = 0; i <= 10; i++) {
        arr.push(
          this.livestockGrossProjected[i] -
          this.fertiliserCostProjected[i] -
          this.fertiliserSpreadCostProjected[i] -
          this.livestockPurchaseCost[i]
        );
      }
      return arr;
    },

    // Cumulative Cash Flow Summary

    ccfAnnualDifference: function(this: any): number[] {
      let arr: number[] = [];
      for (let i = 0; i <= 10; i++) {
        arr.push(this.netCashProjected[i] - this.netCash);
      }
      return arr;
    },
    ccfPosition: function(this: any) {
      let arr: number[] = [];
      for (let i = 0; i <= 10; i++) {
        if (i === 0) {
          arr.push(0);
        } else if (i === 1) {
          arr.push(this.ccfAnnualDifference[1]);
        } else {
          arr.push(this.ccfAnnualDifference[i] + arr[i - 1]);
        }
      }
      return arr;
    },
    ccfInterest: function(this: any) {
      let arr: any[] = [];
      let arrInterest: number[] = [];
      let arrDifference: number[] = [];
      for (let i = 0; i <= 10; i++) {
        if (i === 0) {
          arrInterest.push(0);
          arrDifference.push(0);
        } else if (i === 1) {
          // interestOnDebt
          arrInterest.push(
            Math.round(
              (this.ccfAnnualDifference[1] * (this.data[17].value / 100)) / 2
            )
          );
          arrDifference.push(this.ccfPosition[i] + arrInterest[i]);
        } else {
          arrInterest.push(
            Math.round(
              arrDifference[i - 1] * (this.data[17].value / 100) +
                (this.ccfAnnualDifference[i] * (this.data[17].value / 100)) / 2
            )
          );
          arrDifference.push(this.ccfPosition[i] + arrInterest[i]);
        }
      }
      arr[0] = arrInterest;
      arr[1] = arrDifference;
      return arr;
    },
    additionalLivestockCapital: function(this: any) {
      let arr: number[] = [];
      for (let i = 0; i <= 10; i++) {
        if (i === 0) {
          arr.push(0);
        } else if (i === 1) {
          arr.push(this.livestockPurchaseCost[i]);
        } else {
          arr.push(this.livestockPurchaseCost[i] + arr[i - 1]);
        }
      }
      return arr;
    },
    internalReturnRate: function(this: any) {
      let arr: any[] = [];
      let currentStockingRate: number = +this.data[2].value;
      let targetStockingRate: number = +this.data[5].value;

      if (currentStockingRate < targetStockingRate) {
        let irrFiveYears = this.ccfAnnualDifference.slice(1, 5);
        irrFiveYears.push(
          this.additionalLivestockCapital[5] + this.ccfAnnualDifference[5]
        );
        let irrTenYears = this.ccfAnnualDifference.slice(1, 10);
        irrTenYears.push(
          this.additionalLivestockCapital[10] + this.ccfAnnualDifference[10]
        );

        // IRR must contain at least 1 positive and negative value
        // must produce a result
        let irrValid = true;
        try {
          this.finance.IRR(...irrTenYears);
        } catch (err) {
          if (err) {
            // console.log(err.message)
            irrValid = false;
          }
        }

        if (irrValid) {
          for (let i = 0; i <= 10; i++) {
            if (i === 5) {
              let sum = irrFiveYears.reduce((a: number, b: number) => a + b);
              sum < 0
                ? arr.push("negative")
                : arr.push(Math.round(this.finance.IRR(...irrFiveYears)));
            } else if (i === 10) {
              let sum = irrTenYears.reduce((a: number, b: number) => a + b);
              sum < 0
                ? arr.push("negative")
                : arr.push(Math.round(this.finance.IRR(...irrTenYears)));
            } else {
              arr.push(null);
            }
          }
        }
      }

      return arr;
    }
  },

  methods: {
    // Save / Load Scenarios

    // Using native JSON functions removes reactivity
    // so we can clone an object without mutating the original source
    cleanSource: function(source: any) {
      return JSON.parse(JSON.stringify(source));
    },

    loadScenario: function(this:any) {
      this.updateScenario()
    },

    updateScenario: function(this:any) {
      this.updateExport();
      store.dispatch('updateStep5', store.state.step5);
      this.tablesKey += 1;
    },

    // Charts

    chartData: function(this:any, id: number) {
      let chart1 = {
        datasets: [
          {
            type: "line",
            label: "Cumulative cash flow difference",
            backgroundColor: "#0000FF",
            borderColor: "#0000FF",
            borderWidth: 2,
            pointBackgroundColor: "#FFFFFF",
            pointBorderColor: "#0000FF",
            pointStyle: "circle",
            fill: false,
            data: this.ccfInterest[1].map((i: number, ix: number) => {
              return { x: ix, y: i / 100 };
            }),
            yAxisID: "y"
          },
          {
            type: "line",
            label: "Projected net cash result",
            backgroundColor: "#000000",
            borderColor: "#000000",
            borderWidth: 2,
            pointBackgroundColor: "#000000",
            pointBorderColor: "#000000",
            pointStyle: "circle",
            fill: false,
            data: this.netCashProjected.map((i: number, ix: number) => {
              return { x: ix, y: i / 100 };
            }),
            yAxisID: "y"
          },
          {
            type: "line",
            label: "Current net cash result",
            backgroundColor: "#000000",
            borderColor: "#000000",
            borderWidth: 2,
            pointBackgroundColor: "transparent",
            pointBorderColor: "transparent",
            pointStyle: "line",
            borderDash: ["4", "2"],
            fill: false,
            data: [
              { x: 0, y: this.netCash / 100 },
              { x: 10, y: this.netCash / 100 }
            ],
            yAxisID: "y"
          }
        ]
      };
      let chart2 = {
        datasets: [
          {
            type: "line",
            label: "Stocking rate",
            backgroundColor: "#FF0000",
            borderColor: "#FF0000",
            borderWidth: 2,
            pointBackgroundColor: "#FF0000",
            pointBorderColor: "#FF0000",
            pointStyle: "triangle",
            fill: false,
            data: this.stockingRateProjected.map((i: number, ix: number) => {
              return { x: ix, y: i };
            }),
            yAxisID: "y"
          },
          {
            type: "line",
            label: "Soil fertility",
            backgroundColor: "#008000",
            borderColor: "#008000",
            borderWidth: 2,
            pointBackgroundColor: "#008000",
            pointBorderColor: "#008000",
            pointStyle: "rectRot",
            fill: false,
            data: this.expectedSoilP.map((i: number, ix: number) => {
              return { x: ix, y: i };
            }),
            yAxisID: "y1"
          }
        ]
      };
      return id === 1 ? chart1 : chart2;
    },

    chartOptions: function(this: any, id: number) {
      let ctx = this;
      return {
        responsive: true,
        maintainAspectRatio: true,
        interaction: {
          mode: "index",
          intersect: false
        },
        stacked: false,
        scales: {
          x: {
            type: "linear",
            display: true,
            position: "bottom",
            offset: true,
            title: {
              display: true,
              text: "Time from start of fertiliser program (years)",
              color: "#000",
              font: {
                size: 14
              },
              padding: {
                top: 15
              }
            },
            ticks: {
              stepSize: 0.5,
              color: "#000",
              callback: function(val: any, index: number) {
                return index % 2 === 0 ? val : "";
              }
            },
            grid: {
              color: "rgba(0,0,0,0.05)",
              tickColor: "#000",
              borderColor: "#000"
            }
          },
          y: {
            type: "linear",
            display: true,
            position: "left",
            beginAtZero: true,
            suggestedMax: parseFloat(this.data[5].value) + 2,
            title: {
              display: true,
              text: id === 1 ? "Cash flow ($/ha)" : "Stocking rate (DSE/ha)",
              color: "#000",
              font: {
                size: 14
              },
              padding: {
                bottom: 15
              }
            },
            ticks: {
              color: "#000",
              callback: function(val: any) {
                return id === 1 ? ctx.$options.filters.money(val) : val;
              }
            },
            grid: {
              color: function(context:any) {
                if (context.tick.value === 0) {
                  return "rgba(0,0,0,0.5)";
                }
                return "rgba(0,0,0,0.05)";
              },
              tickColor: "#000",
              borderColor: "#000"
            }
          },
          y1: {
            type: "linear",
            display: id === 2,
            position: "right",
            beginAtZero: true,
            suggestedMax: parseFloat(this.data[4].value) + 2,
            // suggestedMax: 40,
            title: {
              display: true,
              text: "", //"Soil fertility level (mg P/kg)",
              color: "#000",
              font: {
                size: 14
              },
              padding: {
                bottom: 15
              }
            },
            ticks: {
              color: "#000"
            },
            grid: {
              color: function(context:any) {
                if (context.tick.value === 0) {
                  return "rgba(0,0,0,0.5)";
                }
                return "rgba(0,0,0,0.05)";
              },
              drawOnChartArea: false,
              tickColor: "#000",
              borderColor: "#000"
            }
          }
        },
        plugins: {
          chartCustomization: {
            borderColor: "rgba(0,0,0,0.1)",
            borderWidth: 1
          },
          tooltip: {
            callbacks: {
              label: function(context: any) {
                let label = context.dataset.label || "";
                if (label) {
                  label += ": ";
                }
                if (context.parsed.y !== null) {
                  if (id === 1) {
                    label += ctx.$options.filters.money(
                      parseFloat(context.parsed.y.toFixed(2))
                    );
                  } else {
                    label += parseFloat(context.parsed.y.toFixed(2));
                  }
                }
                return label;
              },
              labelColor: function(context: any) {
                let dataset =
                  context.chart.config.data.datasets[context.datasetIndex];
                return {
                  borderColor:
                    dataset.backgroundColor != "transparent"
                      ? dataset.backgroundColor
                      : dataset.borderColor,
                  backgroundColor:
                    dataset.backgroundColor != "transparent"
                      ? dataset.backgroundColor
                      : dataset.borderColor,
                  borderRadius: 5
                };
              },
              title: function(context: any) {
                return "Year: " + context[0].label;
              }
            }
          },
          legend: {
            display: true,
            labels: {
              usePointStyle: true,
              boxWidth: 8,
              color: "#000",
              font: {
                size: 12
              },
              generateLabels: function(chart: any) {
                let data = chart.data;
                let legends = Array.isArray(data.datasets)
                  ? data.datasets.map(function(dataset: any, i: number) {
                      return {
                        text: dataset.label,
                        datasetIndex: i,
                        fillStyle: dataset.borderDash
                          ? "transparent"
                          : dataset.backgroundColor,
                        hidden: !chart.isDatasetVisible(i),
                        strokeStyle: dataset.borderColor,
                        pointStyle: "line",
                        lineDash: dataset.borderDash,
                        lineWidth: 2
                      };
                    }, this)
                  : [];
                return legends;
              }
            }
          }
        }
      };
    },

    // Other Functions

    validateTimeframe: async function(this: any, newTimeframe: any) {
      newTimeframe = parseInt(newTimeframe);
      let originalTimeframe: number = this.data[6].result;
      if (newTimeframe != originalTimeframe) {
        if (
          await this.$refs.confirm.open(
            "New timeframe",
            "The timeframe you entered differs from that given in Step 3. Return to Step 3 to recalculate the rate of P application needed to meet your target for this timeframe.",
            {
              color: "red",
              cta: "Accept value"
            }
          )
        ) {
          // Accept new timeframe
          this.data[6].value = newTimeframe;
          return newTimeframe;
          // Cancel
        } else {
          this.data[6].value = originalTimeframe;
          return originalTimeframe;
        }
      } else {
        this.data[6].value = originalTimeframe;
        return originalTimeframe;
      }
    },

    // Update budget tables on value changes
    change: async function(this: any, event: number, item: any) {
      switch (item.id) {
        case "11":
          store.state.step5.fertRate = item.value
          break;
        case "12":
          store.state.step5.currentGrossMargin = item.value
          break;
        case "13":
          store.state.step5.projectedGrossMargin = item.value
          break;
        case "14":
          store.state.step5.extraLivestockCost = item.value
          break;
        case "15":
          store.state.step5.fertCost = item.value
          break;
        case "16":
          store.state.step5.fertSpread = item.value
          break;
        case "17":
          store.state.step5.interestOnDebt = item.value
          break;
        case "18":
          store.state.step5.pastureArea = item.value
          break;
        default:
          break;
      }

      if (event !== undefined) {
        // Error check
        let x = event.toString();
        if (x.length > 0) {
          item.value = parseFloat(x);
        } else {
          store.state.errorAlert = true;
        }

        // Timeframe validation
        let validatedTimeframe: number = parseInt(this.data[6].result);
        if (item.id === "6") {
          validatedTimeframe = await this.validateTimeframe(event);
        }

        // Update yearly increase values
        if (["2", "5", "6"].includes(item.id)) {
          let currentStockingRate =
            item.id === "2" ? event : this.data[2].value;
          let targetStockingRate = item.id === "5" ? event : this.data[5].value;
          this.data[7].value =
            (targetStockingRate - currentStockingRate) / validatedTimeframe;
        }
        if (["0", "4", "6"].includes(item.id)) {
          let currentSoilP = item.id === "0" ? event : this.data[0].value;
          let targetSoilP = item.id === "4" ? event : this.data[4].value;
          this.data[8].value =
            (targetSoilP - currentSoilP) / validatedTimeframe;
        }

        this.updateExport();
        store.dispatch("updateStep5", store.state.step5);

        // Update
        this.tablesKey += 1;
      }
    },

    // Update exported data
    updateExport(this:any) {
      let current:any = {
        stockingRate: [],
        fertiliserRate: [],
        livestockGrossCurrent: [],
        fertiliserCost: [],
        fertiliserSpreadCost: [],
        netCashSpecified: [],
        netCashHa: []
      }
      let projected:any = {
        stockingRate: [],
        fertiliserRate: [],
        expectedSoilP: [],
        grossMarginPerHead: [],
        livestockGross: [],
        fertiliserCost: [],
        fertiliserSpreadCost: [],
        livestockPurchaseCost: [],
        netCashSpecified: [],
        netCashHa: []
      }
      let summary:any = {
        ccfAnnualDifference: [],
        ccfPosition: [],
        interestOnCCF: [],
        ccfDifferenceInterestSpecified: [],
        ccfDifferenceInterestHa: [],
        additionalLivestockCapital: [],
        internalReturnRate: []
      }

      // Years 0 - 10
      for (let y = 0; y < 11; y++) {
        // Current
        current.stockingRate.push(this.data[2].value);
        current.fertiliserRate.push(this.data[11].value);
        current.livestockGrossCurrent.push(this.livestockGrossCurrent);
        current.fertiliserCost.push(this.fertiliserCost);
        current.fertiliserSpreadCost.push(this.fertiliserSpreadCost);
        current.netCashSpecified.push(this.netCash);
        current.netCashHa.push((this.netCash / this.data[18].value) || 0);
        // Projected
        projected.stockingRate.push(this.stockingRateProjected[y]);
        projected.fertiliserRate.push(this.fertilserRate[y]);
        projected.expectedSoilP.push(this.expectedSoilP[y]);
        projected.grossMarginPerHead.push(this.grossMarginPerHead[y]);
        projected.livestockGross.push(this.livestockGrossProjected[y]);
        projected.fertiliserCost.push(this.fertiliserCostProjected[y]);
        projected.fertiliserSpreadCost.push(this.fertiliserSpreadCostProjected[y]);
        projected.livestockPurchaseCost.push(this.livestockPurchaseCost[y]);
        projected.netCashSpecified.push(this.netCashProjected[y]);
        projected.netCashHa.push((this.netCashProjected[y] / this.data[18].value) || 0);
        // Summary
        summary.ccfAnnualDifference.push(this.ccfAnnualDifference[y])
        summary.ccfPosition.push(this.ccfPosition[y])
        summary.interestOnCCF.push(this.ccfInterest[0][y])
        summary.ccfDifferenceInterestSpecified.push(this.ccfInterest[1][y])
        summary.ccfDifferenceInterestHa.push((this.ccfInterest[1][y] / 100))
        summary.additionalLivestockCapital.push(this.additionalLivestockCapital[y])
        summary.internalReturnRate.push(this.internalReturnRate[y])
      }

      store.state.step5.exportDataEntry = this.cleanSource(this.data);
      store.state.step5.exportResults = {
        current: current,
        projected: projected,
        summary: summary
      }
    },

    // Print the selected table
    printTable: function(this: any, tableId: string) {
      // Get table
      let divToPrint: any = document.getElementById(tableId);

      // Add styles
      divToPrint.style.textAlign = "left";
      divToPrint.style.fontFamily = '"Roboto", sans-serif';
      let th: any = document.getElementsByTagName("th");
      th.forEach((element: any) => {
        element.style.fontSize = "12px";
        element.style.textAlign = 'left';
      });
      let td: any = document.getElementsByTagName("td");
      td.forEach((element: any) => {
        element.style.fontSize = "12px";
        element.style.outline = "thin solid #e7e7e7";
      });
      // Hide buttons and icons
      let buttons: any = document.getElementsByTagName("button");
      buttons.forEach((element: any) => {
        element.style.display = "none";
      });
      let icons: any = document.getElementsByClassName("v-icon");
      icons.forEach((element: any) => {
        element.style.display = "none";
      });

      // Open Print window
      let newWin: any = window.open();
      newWin.document.write(divToPrint.outerHTML);
      newWin.print();

      // Remove styles
      divToPrint.style.textAlign = "inherit";
      divToPrint.style.fontFamily = "inherit";
      td.forEach((element: any) => {
        element.style.fontSize = "inherit";
        element.style.outline = "inherit";
      });
      buttons.forEach((element: any) => {
        element.style.display = "inline-flex";
      });
      icons.forEach((element: any) => {
        element.style.display = "inline";
      });

      // Close
      newWin.close();
    }
  },

  store
};
